/**
 * CRM API
 * General CRM operations: assignees, tags, blacklist, stats
 */

import { crmGet, crmPost, crmPut, crmDelete, mainGet } from './crmConfig';

// ─── CRM Assignees (dedicated crmassignees collection) ──────────────────────

export const fetchCRMAssignees = async () => {
  const response = await crmGet('/api/crm-assignees');
  return response.data;
};

export const createCRMAssignee = async (data) => {
  const response = await crmPost('/api/crm-assignees', data);
  return response.data;
};

export const updateCRMAssignee = async ({ id, data }) => {
  const response = await crmPut(`/api/crm-assignees/${id}`, data);
  return response.data;
};

export const deleteCRMAssignee = async (id) => {
  const response = await crmDelete(`/api/crm-assignees/${id}`);
  return response.data;
};

// ─── Assignees ────────────────────────────────────────────────────────────────

/**
 * Fetch all assignees
 */
export const fetchAssignees = async () => {
  const response = await crmGet('/api/assignees');
  return response.data;
};

/**
 * Create a new assignee
 */
export const createAssignee = async (data) => {
  const response = await crmPost('/api/assignees', data);
  return response.data;
};

/**
 * Update an assignee
 */
export const updateAssignee = async ({ id, data }) => {
  const response = await crmPut(`/api/assignees/${id}`, data);
  return response.data;
};

/**
 * Delete an assignee
 */
export const deleteAssignee = async (id) => {
  const response = await crmDelete(`/api/assignees/${id}`);
  return response.data;
};

/**
 * Fetch assignee tags
 */
export const fetchAssigneeTags = async () => {
  const response = await crmGet('/api/assignees/tags');
  return response.data;
};

/**
 * Update assignee tags
 */
export const saveAssigneeTags = async (tags) => {
  const response = await crmPut('/api/assignees/tags', tags);
  return response.data;
};

/**
 * Fetch merged assignees from main API (port 4000)
 */
export const fetchMergedAssignees = async () => {
  const response = await mainGet('/api/assignees/merged');
  return response.data;
};

// ─── Lead Tags ────────────────────────────────────────────────────────────────

/**
 * Fetch all lead tags
 */
export const fetchLeadTags = async () => {
  const response = await crmGet('/api/leads/lead-tags');
  return response.data;
};

/**
 * Save lead + patient tags. Backend expects { leadTags, patientTags }
 * and stores them under tags.leads / tags.patients.
 */
export const saveLeadTags = async ({ leadTags, patientTags }) => {
  const response = await crmPut('/api/leads/lead-tags', { leadTags, patientTags });
  return response.data;
};

// ─── Blacklist ────────────────────────────────────────────────────────────────

/**
 * Fetch blacklisted users
 */
export const fetchBlacklist = async () => {
  const response = await crmGet('/api/leads/blacklist');
  return response.data;
};

/**
 * Add user to blacklist
 */
export const addToBlacklist = async (userId) => {
  const response = await crmPost('/api/leads/blacklist', { userId });
  return response.data;
};

/**
 * Remove user from blacklist
 */
export const removeFromBlacklist = async (userId) => {
  const response = await crmPost('/api/leads/blacklist-remove', { userId });
  return response.data;
};

// ─── Stats & Counts ───────────────────────────────────────────────────────────

/**
 * Fetch unread counts for leads
 */
export const fetchUnreadCounts = async () => {
  const response = await crmGet('/api/leads/getunreadcounts');
  return response.data;
};

/**
 * Fetch pipeline statistics
 */
export const fetchPipelineStats = async () => {
  const response = await crmGet('/api/leads/pipeline-stats');
  return response.data;
};

/**
 * Fetch Cognito groups from main API
 */
export const fetchCognitoGroups = async () => {
  const response = await mainGet('/auth/cognito/groups');
  return response.data;
};
